import React, { useState } from "react";
import { ReactComponent as ExportIcon } from "../../../../assets/upload-edit.svg";
import { Row, Col, Button, Popover, Select, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import "./index.less";
import axios from "axios";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import UseDocControlPermissions from "../../permissions/useDocControlPermissions";

const { Option } = Select;

const ExportDoc = ({ project_id, allMaterialControl }) => {
  const [materialType, setMaterialType] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, , canExport] = UseDocControlPermissions();

  // const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  
  // Define material types
  const materialTypes = [
    { type: 'material', name: 'Material' },
    { type: 'bolts', name: 'Bolts' },
  ];
  const handleDownload = (blob) => {
    // Create a blob URL from the data
    const url = window.URL.createObjectURL(blob);
    
    // Generate filename with current date and time
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0].replace(/-/g, ''); // Format: YYYYMMDD
    const timeStr = today.toTimeString().split(' ')[0].replace(/:/g, ''); // Format: HHMMSS
    const fileName = `${materialType}-export-${dateStr}${timeStr}.xlsx`;
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    
    // Append to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the blob URL
    window.URL.revokeObjectURL(url);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Prepare search parameters if they exist
      let params = {
        type: materialType,
        projectId: project_id
      };
      
      // Add search parameters if they exist
      if (allMaterialControl && allMaterialControl.length > 0) {
        // Extract all IDs from the allMaterialControl array
        const ids = allMaterialControl.map(item => item.id);
        params = { ...params, ids };
      }
      
      const res = await axios.get('/material-control-registers/export', {
        params,
        responseType: 'blob' // Important: This tells axios to handle the response as binary data
      });

      // No need to extract filename from headers, we'll generate our own
      handleDownload(res.data);
      setSuccess(true);
    } catch (error) {
      console.error('Export error:', error);
      message.error("Failed to export data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const cleanupFun = () => {
    setMaterialType(null);
    setSuccess(false);
  };

  const onOpenChange = (e) => {
    if (!e) {
      console.log("onOpenChange", e);
      cleanupFun();
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    cleanupFun();
  };

  // useEffect(() => {
  //   return () => {
  //     console.log("cleanup func");
  //     setSelectedId(null);
  //   };
  // }, []);

  const SuccessSection = () => {
    return (
      <Col>
        <Row justify="center" gutter={[0, 20]} className="success-row">
          <Col span={24}>
            <div className="success-text">Document Exported Successfully</div>
          </Col>
          <Col span={24}>
            <Button size="small" onClick={handleClose} className="close-btn">
              CLOSE
            </Button>
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <Popover
      overlayClassName="export-popover"
      placement="topRight"
      getPopupContainer={() =>
        document.getElementsByClassName(
          "ant-layout-content layout-content site-layout-background custom-textarea"
        )[0]
      }
      content={
        <Row justify="center" gutter={[0, 40]} className="parent-div">
          <Col span={24} className="choose-col">
            <div className="choose-select-div">
              <label>{"TYPE"}</label>
              <Row className={success ? "readonly-select-row" : ""}>
                <Select
                  placeholder="Select Document Type"
                  disabled={success}
                  size="small"
                  getPopupContainer={() =>
                    document.getElementsByClassName(
                      "ant-layout-content layout-content site-layout-background custom-textarea"
                    )[0]
                  }
                  onChange={(e) => setMaterialType(e)}
                  value={materialType}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {materialTypes.map((el) => {
                    const { type, name } = el;
                    return (
                      <Option value={type} key={type}>
                        {name}
                      </Option>
                    );
                  })}
                </Select>
              </Row>
            </div>
          </Col>
          {success ? (
            <SuccessSection />
          ) : (
            <Col>
              {materialType && (
                <Button
                  size="middle"
                  icon={<ExportIcon />}
                  loading={loading}
                  onClick={handleSave}
                  className={`export-btn`}
                >
                  EXPORT FILE
                </Button>
              )}
            </Col>
          )}
        </Row>
      }
      onOpenChange={onOpenChange}
      title={
        <Row justify="space-between">
          <Col className="title">EXPORT</Col>
          <Col>
            <CloseOutlined onClick={handleClose} />
          </Col>
        </Row>
      }
      trigger="click"
      open={isVisible}
      onVisibleChange={(e) => {
        canExport && setIsVisible(e);
      }}
    >
      <ExportIcon className={`${canExport ? "orange-icon" : "cursor-not-allowed"}`} />
    </Popover>
  );
};

export default ExportDoc;
